module.exports = __webpack_public_path__ + "static/media/bgOptimization.7654f1de.jpg";